import React, { ChangeEvent, LegacyRef } from 'react';
import { Input } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
// import Loader from '../ui/content/Loader';

import ClinicFilter from 'components/calendar/filters/clinicFilter/index';
import {
  ICalendarFilterOption,
  IClinicFilterData
} from 'model/calendar/filters';

export const searchValueContext = React.createContext('');
interface Props {
  clinicFiltersRef: LegacyRef<HTMLDivElement> | undefined;
  handleGenericBlur: (
    e: React.FocusEvent<HTMLDivElement>,
    filterType: string
  ) => void;
  toggleFilterList: (type: string) => void;
  filterDropdownExpand: Record<string, Boolean>;
  handleGenericSearch: (
    _e: ChangeEvent<HTMLInputElement>,
    data: { value: string | number },
    typeOfSearch: string
  ) => void;
  searchValue: Record<string, string>;
  hasClinics: boolean;
  isLoading: boolean | undefined;
  FilterData: IClinicFilterData[];
  handleClinicSearchedValues: (
    list: ICalendarFilterOption[]
  ) => ICalendarFilterOption[];
  checkedClinics: ICalendarFilterOption[];
  setCheckedClinics: React.Dispatch<
    React.SetStateAction<ICalendarFilterOption[]>
  >;
  setHasClinics: React.Dispatch<React.SetStateAction<boolean>>;
  clearFilter: (clearFilter: any) => void;
  Loader: React.FC;
  type: string;
  placeHolder?: string;
  title?: string;
}
const MainFilter = ({
  clinicFiltersRef,
  handleGenericBlur,
  toggleFilterList,
  filterDropdownExpand,
  handleGenericSearch,
  searchValue,
  hasClinics,
  isLoading,
  FilterData,
  handleClinicSearchedValues,
  checkedClinics,
  setCheckedClinics,
  setHasClinics,
  clearFilter,
  Loader,
  type,
  placeHolder,
  title
}: Props) => {
  return (
    <div
      ref={clinicFiltersRef}
      onBlur={e => handleGenericBlur(e, type)}
      tabIndex={-1}
    >
      <div
        className="filter-input_wrapper waitList_input_wrapper"
        onClick={() => toggleFilterList(type)}
      >
        <Input
          className="filter_input_waitlist"
          placeholder={
            filterDropdownExpand[type]
              ? 'Search'
              : placeHolder
              ? placeHolder
              : 'Clinic Name'
          }
          onChange={event =>
            handleGenericSearch(
              event,
              { value: event.currentTarget.value },
              type
            )
          }
        />
        {!filterDropdownExpand[type] && (
          <FontAwesomeIcon className="icon" icon={faCaretDown} />
        )}
        {filterDropdownExpand[type] && (
          <FontAwesomeIcon
            className="icon"
            icon={faCaretDown}
            style={{ opacity: 0 }}
          />
        )}
      </div>
      {filterDropdownExpand[type] && (
        <>
          <searchValueContext.Provider value={searchValue[type]}>
            <div
              className="list_wrapper"
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                zIndex: 1,
                width: '100%'
              }}
            >
              <div className="scrollable_list">
                {!hasClinics && !isLoading && (
                  <p className="no-results_filter">No results found</p>
                )}
                {isLoading && <Loader />}
                {!isLoading && (
                  <ClinicFilter
                    clinicsList={FilterData || []}
                    handleSearchedValues={handleClinicSearchedValues}
                    checkedClinics={checkedClinics}
                    setCheckedClinics={setCheckedClinics}
                    setHasData={setHasClinics}
                    title={title}
                  />
                )}
              </div>
              <div className="calender-filters_actions">
                <span onClick={() => clearFilter(setCheckedClinics)}>
                  Clear all
                </span>
              </div>
            </div>
          </searchValueContext.Provider>
        </>
      )}
    </div>
  );
};

export default MainFilter;
